import classNames from 'classnames';
import { FC, useContext } from 'react';

import { ROUTES_BY_SERVICE_CODE } from '@/router/config';

import { FeatureContext } from '@/contexts/Features/FeatureContext';

import { SERVICE_CODES } from '@/lib/consts';

import { FeatureName } from '@/api/types';

import { Typography, LinkAsButton, ButtonSizes, ButtonVariant, Status, ConditionView } from '../../..';
import { BaseCard } from '../../model/BaseCard/BaseCard';
import { ServiceRowCardVariant, WeaponRegisteredCardProps } from '../../model/types';
import { DetailedButton } from '../ActionButtons/DetailedButton';
import { CardAccordion } from '../CardAccordion/CardAccordion';
import { RowRenderer } from '../RowRenderer';
import { WeaponPartCard } from '../WeaponPartCard';

import { expirationPermitInformer, getRow1, getRow2, purchasePermitInformer, statuses } from './constants';

export const WeaponRegisteredCard: FC<WeaponRegisteredCardProps> = ({ data, variant, onDetailedClick }) => {
  const { isFeatureAvailable } = useContext(FeatureContext);

  const expiredInformer = expirationPermitInformer(data.daysLeftForPermitExpiration);

  const purchaseInformer = purchasePermitInformer(data.daysLeftForPurchaseOperation);

  return (
    <BaseCard
      className={classNames('service-row-card', `service-row-card--${variant}`)}
      header={
        <div className="service-row-card__status-wrapper">
          {data.statuses.map((status) => (
            <Status key={status} status={statuses[status]} />
          ))}
        </div>
      }
      body={
        <>
          <div className="service-row-card__meta-wrapper">
            <RowRenderer rows={getRow1(data)} />
          </div>
          <div className="service-row-card__meta-wrapper">
            <RowRenderer rows={getRow2(data)} />
          </div>
        </>
      }
      informer={purchaseInformer || expiredInformer}
      accordion={
        data.weaponType === 'firearm' && data.parts?.length ? (
          <CardAccordion
            items={[
              {
                label: <Typography className="service-row-card__accordion-label">Основні частини зброї</Typography>,
                children: (
                  <div className="service-row-card__accordion-content">
                    {data.parts.map((part) => (
                      <WeaponPartCard
                        key={`${part.type}-${part.serialNum}`}
                        status={data.statuses[0]}
                        data={part}
                        variant={ServiceRowCardVariant.WEAPON_PART}
                      />
                    ))}
                  </div>
                ),
              },
            ]}
          />
        ) : undefined
      }
      actions={[
        <ConditionView key="detailed-info" if={data.weaponType !== 'firearm_part'}>
          <DetailedButton onClick={(): void => onDetailedClick()} />
        </ConditionView>,
        <ConditionView
          if={!!data.daysLeftForPermitExpiration && isFeatureAvailable(FeatureName.ERZ_SERVICES)}
          key="extend-validity-period"
        >
          <LinkAsButton
            size={ButtonSizes.SM}
            variant={ButtonVariant.PRIMARY}
            to={ROUTES_BY_SERVICE_CODE[SERVICE_CODES.VALIDITY_PERIOD_PROLONGATION]}
          >
            Подовжити термін дії дозволу
          </LinkAsButton>
        </ConditionView>,
      ]}
    />
  );
};
